export class HospitalLocationsListModule {
    constructor() {
        if ($(".hospital-locations-list").length > 0) {
            this.init(); 
        }
    }

    init() {     

        $(".list-block-wrapper").on("click", ".list-block-content>a", function (e) {
            e.preventDefault();
            if (document.documentElement.clientWidth < 975) {
                $(this).parent().find("ul").toggle();
                $(this).hasClass("active") ? $(this).removeClass("active") : $(this).addClass("active");
                $(this).parent().find("ul").attr("aria-expanded", $(this).parent().find("ul").is(':visible'));
            }
            
        });

        $(window).resize(function () {
            document.documentElement.clientWidth > 975 ?
                $(".list-block-wrapper").find("ul").show() : $(".list-block-wrapper").find("ul").hide();
        })


    }
}
  
    




